import { render, staticRenderFns } from "./DerivativesSimulatorPage.vue?vue&type=template&id=c505ae00&scoped=true"
import script from "./DerivativesSimulatorPage.vue?vue&type=script&lang=js"
export * from "./DerivativesSimulatorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c505ae00",
  null
  
)

export default component.exports